import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@heroui/react";
import ButtonNew from "components/buttonNew/buttonNew";
import { Check } from "@phosphor-icons/react";
import { AlertCircle } from 'assets/icons';

interface DeleteConversationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
}

const DeleteConversationModal: React.FC<DeleteConversationModalProps> = ({ isOpen, onClose, onDelete }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalContent>
                <ModalHeader className="flex flex-col gap-1">
                    <p className="flex items-center gap-1 text-sm font-medium text-status-bad">
                        <AlertCircle className="h-[17px] w-[17px]" /> Delete Conversation
                    </p>
                </ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this conversation? This action cannot be undone.</p>
                </ModalBody>
                <ModalFooter>
                    <ButtonNew
                        variant="primaryBrick"
                        onClick={onDelete}
                        icon={<Check />}
                        label="Delete Conversation"
                    />
                    <ButtonNew
                        variant="secondaryNeutral"
                        onClick={onClose}
                        label="Cancel"
                    />
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConversationModal;